import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Toast } from 'primereact';
import { useNavigate } from 'react-router-dom';
import { ConfirmDialog } from 'primereact/confirmdialog'; // To use <ConfirmDialog> tag
import { confirmDialog } from 'primereact/confirmdialog'; // To use confirmDialog method



import Card from '../../../Base/Components/Card/Card';
import { toastShow } from '../../../Base/Services/ToastService';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';


import { AccesoUser, getAccesosWebUser } from '../../../API/IT/Accesos/AccesosRequests'
import { cambiarPermisoEvaluacionPlanta, cambiarPermisoEvaluacionRRHH, 
    cambiarPermisoEvaluacionSupervisor, cancelarEvaluacion, getAllLisEvaluacion, getLisEvaluacion } from '../../../API/RRHH/Evaluacion/EvaluacionPersonalRequets';

import DialogPassword from '../../../Base/Components/Dialog/DialogPassword/DialogPassword';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../Base/Services/Config/ConfigService';
import { Dropdown } from 'primereact/dropdown';




const EvaluacionPersonalList = ({router}) => {

    const { userAuth } = useContext(AuthContext);



    const toast = useRef(null);
    const [evaluaciones, setEvaluaciones] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState('');
    const [permisoChange, setPermisoChange] = useState(null);
    const [selectedYear, setSelectedYear] = useState(1);

    const navigate = useNavigate();



    const años = [
        { label: 'Todas', value: 1 },
        { label: '2022', value: 2022 },
        { label: '2023', value: 2023 },
        { label: '2024', value: 2024 },
        { label: '2025', value: 2025 },
        { label: '2026', value: 2026 },
        { label: '2027', value: 2027 },
    ];



    const getInfo = async () => {
        setLoading(true);

        let a;
        if (userAuth.AccesosWeb.length > 0) {
            if (userAuth.AccesosWeb.split(',').map(e => parseInt(e)).includes(6)) {
                a = await getAllLisEvaluacion();
            } else {
                a = await getLisEvaluacion();
            }
        } else {
            a = await getLisEvaluacion();
        }

        if (a && a.length > 0 && selectedYear !== 1) {
            a = a.filter(evaluation => evaluation.Anio === selectedYear);
            setEvaluaciones(a);
        }else{
            setEvaluaciones(a);
        }

        setLoading(false);
    }

    useEffect(() => {
        getInfo();
        setTitlePage('Evaluación de personal');
    }, [selectedYear]);


    const botones = (rowData) => {
        if(!rowData.idpersonal) return (<div></div>)
        return <div style={{ display: 'flex', gap: 2, fontSize: 10 }}>
            <Button className='p-button-text px-2' icon='pi pi-eye' onClick={e => {
                // navigate(``, { replace: true })
                // console.log(selected)
                window.open(`${process.env.REACT_APP_ENV}/RRHH/EvaluacionPersonal/${rowData.IdEvaluacion}`, rowData.IdEvaluacion, 'height=1200,width=1000')

                // if (selected.length > 0) {
                //     const selectedIds = selected.map(id => id.IdEvaluacion).join(',');
                //     window.open(`${process.env.REACT_APP_ENV}/RRHH/EvaluacionPersonal/${selectedIds}`, '_blank', 'height=1200,width=1000');
                // } else {
                //     window.open(`${process.env.REACT_APP_ENV}/RRHH/EvaluacionPersonal/${rowData.IdEvaluacion}`, rowData.IdEvaluacion, 'height=1200,width=1000')

                // }


            }
            } />
            {userAuth.IdRol === 1 && <Button className='p-button-text px-2' icon='pi pi-ban' onClick={async (e) => {
                // navigate(``, { replace: true })
                if (selected.length > 0) {
                    confirmDialog({
                        message: 'Are you sure you want to proceed?',
                        header: 'Confirmation',
                        icon: 'pi pi-exclamation-triangle',
                        accept: async() => {
                            const t = selected.map(e => e.IdEvaluacion)
                            console.log(t.toString());
                            const a = await cancelarEvaluacion({ IdCheck: t.IdEvaluacion});
                            if (a.length > 0) {
                                toastShow(toast, 'warn', a[0].mssg)
                                getInfo();
                            }
                        },
                    });
                    
                } else {
                    confirmDialog({
                        message: 'Are you sure you want to proceed?',
                        header: 'Confirmation',
                        icon: 'pi pi-exclamation-triangle',
                        accept: async() => {
                            const a = await cancelarEvaluacion({ IdCheck: rowData.IdEvaluacion });
                            if (a.length > 0) {
                                toastShow(toast, 'warn', a[0].mssg)
                                getInfo();
                            }
                        },
                    });
                }

            }

            
        } />}
        {userAuth.AccesosWeb.includes('25') && 
            <Button className='p-button-text px-2' icon='pi pi-pencil'
                onClick={e => {
                    navigate(`/web/RRHH/EditEvaluacionPersonal/${rowData.IdEvaluacion}`)
                    // window.open(`${process.env.REACT_APP_ENV}/RRHH/EditEvaluacionPersonal/${rowData.IdEvaluacion}`)
                }}
            /> 
        }

            {/* <Button className='p-button-text px-2' icon='pi pi-pencil'
                onClick={e => {
                    navigate(`/web/RRHH/EditEvaluacionPersonal/${rowData.IdEvaluacion}`)
                    // window.open(`${process.env.REACT_APP_ENV}/RRHH/EditEvaluacionPersonal/${rowData.IdEvaluacion}`)
                }}
            />  */}
        </div>
    }

    const colums = [
        {
            header: 'ID',
            field: 'IdEvaluacion',
            className: 'XXsmall',
            Sumary: 'count',
            hidden: userAuth?.IdRol === 1
        },
        {
            header: 'Código',
            field: 'idpersonal',
            className: 'small',
            Format: 'Center'
        },
        {
            header: 'Nombre',
            field: 'NombreEmpleado',
            className: 'XXlarge',
            Sumary: 'count'
        },
        {
            header: 'Fecha',
            field: 'Fecha',
        },
        {
            header: 'Posicion',
            field: 'posicion',
        },
        {
            header: 'Seccion',
            field: 'seccion',
        },
        {
            header: 'Calificación',
            field: 'Nota',
            Format: 'Porcentaje',
            className: 'small'
        },
        {
            header: 'Evaluador',
            field: 'evaluador',
        },
        {
            header: 'Año',
            field: 'Anio',
            className: 'Xsmall'
        },
        
        {
            header: 'Supervisor',
            field: 'permiso1',
            Format: 'Checkbox',
            className: 'small',
            frozen: true,
            alignFrozen: 'right',
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data])
                }
                setPermisoChange(1);
                setShowDialog(true)
            }
        },
        {
            header: 'RRHH',
            field: 'permiso2',
            Format: 'Checkbox',
            className: 'Xsmall',
            frozen: true,
            alignFrozen: 'right',
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data])
                }
                setPermisoChange(2);
                setShowDialog(true)
            }
        },
        {
            header: 'Planta',
            field: 'permiso3',
            Format: 'Checkbox',
            className: 'Xsmall',
            frozen: true,
            alignFrozen: 'right',
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data])
                }
                setPermisoChange(3);
                setShowDialog(true)
            }
        },
        {
            header: '',
            field: 'botones',
            className: 'Xsmall',
            frozen: true,
            alignFrozen: 'right',
            Format: 'Template',
            body: botones
        },


    ];

    const table = {
        Columns: colums,
        Data: evaluaciones,
        loading: loading,
        selected: selected,
        setSelected: setSelected
    }

    const onHide = () => {
        setSelected([]);
        setShowDialog(false);
        setPassword('')
    }

    const changePermiso = async (row) => {
        if (selected.length > 0) {
            const a = selected.map(e => e.IdEvaluacion);
            let t = null
            switch (permisoChange) {
                case 1:
                    t = await cambiarPermisoEvaluacionSupervisor({ IdCheck: a.toString(), password, value: selected[0]?.permiso1 ? false : true });
                    break;
                case 2:
                    t = await cambiarPermisoEvaluacionRRHH({ IdCheck: a.toString(), password })
                    break;
                case 3:
                    t = await cambiarPermisoEvaluacionPlanta({ IdCheck: a.toString(), password })
                    break;
                default:
                    break;
            }
            if (t?.length > 0) {
                if (t[0].error) {
                    toastShow(toast, 'warn', t[0].mssg)
                } else {
                    toastShow(toast, 'success', t[0].mssg)
                    getInfo()
                }
            }
        }
        onHide();
        setSelected([]);
    }


    return (
        <div className=''>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card
                titulo={
                <div style={{ display: 'flex', gap: 10 }}>
                    <h3>Evaluación de personal</h3>
                    <Dropdown
                        value={selectedYear}
                        options={años}
                        onChange={(e) => setSelectedYear(e.value)}
                        placeholder="Seleccione el año"
                    />


                    <Button icon='pi pi-search' onClick={getInfo} />
                    <Button icon='pi pi-plus' onClick={e => {
                        navigate("/web/RRHH/NewEvaluacionPersonal", { replace: true })
                    }} />
                </div>}
                contenido={<div style={{ height: '90vh' }} className='pt-4'>
                    <AgGrid table={table} />
                    <DialogPassword
                        display={showDialog}
                        selected={selected}
                        loading={loading}
                        authByUserOrRol={changePermiso}
                        authPermiso={changePermiso}
                        onHide={onHide}
                        password={password}
                        setPassword={setPassword}
                    />
                </div>}
            />
        </div>
    )
}

export default EvaluacionPersonalList